// extracted by mini-css-extract-plugin
export default {"loading":"user_loading__4oRot","pcWrap":"user_pcWrap__WrS23"};